<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable() || dataEmpty()) {
    <app-table-template
      tableTitle="Invoice Summary"
      [showTitle]="true"
      [showSearch]="true"
      [showToggle]="false"
      [hasCardView]="true"
      [showPagination]="true"
      [clickableRows]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="80"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (rowClicked)="rowClicked($event)">
      <app-invoice-summary-card-container [currentPage]="currentPage()"></app-invoice-summary-card-container>
    </app-table-template>
  }
</div>
